// Centralized theme configuration
export const themes = [
  { 
    name: 'default', 
    label: 'Default',
    dark: { primary: '#6e72c3', secondary: '#4b5563' },
    light: { primary: '#8b8cdf', secondary: '#94a3b8' }
  },
  { 
    name: 'grass', 
    label: 'Grass',
    dark: { primary: '#6ec386', secondary: '#4b634f' },
    light: { primary: '#498a63', secondary: '#94b8a1' }
  },
  { 
    name: 'wood', 
    label: 'Wood',
    dark: { primary: '#c39e6e', secondary: '#635e4b' },
    light: { primary: '#cc967b', secondary: '#b8b094' }
  },
  { 
    name: 'ocean', 
    label: 'Ocean',
    dark: { primary: '#0284c7', secondary: '#0369a1' },
    light: { primary: '#0ea5e9', secondary: '#7dd3fc' }
  },
  {
    name: 'mauve',
    label: 'Mauve',
    dark: { primary: '#c36e99', secondary: '#634b5d' },
    light: { primary: '#c2486f', secondary: '#b894aa' }  
  },
  {
    name: 'monotone',
    label: 'Monotone',
    dark: { primary: '#949494', secondary: '#858585' },
    light: { primary: '#4d4d4d', secondary: '#787878' }
  },
  {
    name: 'coral',
    label: 'Coral',
    dark: { primary: '#e57373', secondary: '#f48fb1' },
    light: { primary: '#cd5c5c', secondary: '#dc6b73' }
  },
  {
    name: 'mint',
    label: 'Mint',
    dark: { primary: '#8ac5c1', secondary: '#7db3b0' },
    light: { primary: '#7db3b0', secondary: '#6b9c98' }
  },
  {
    name: 'lavender',
    label: 'Lavender',
    dark: { primary: '#b28fef', secondary: '#8a6bc7' },
    light: { primary: '#9370db', secondary: '#8060c5' }
  },
  {
    name: 'honey',
    label: 'Honey',
    dark: { primary: '#ffc947', secondary: '#ffb74d' },
    light: { primary: '#ffb74d', secondary: '#ff9800' }
  },
  {
    name: 'evergreen',
    label: 'Evergreen',
    dark: { primary: '#386453', secondary: '#889fad' },
    light: { primary: '#5d866f', secondary: '#4f6a7d' }
  },
  {
    name: 'coastal',
    label: 'Coastal',
    dark: { primary: '#91574e', secondary: '#b46767' },
    light: { primary: '#be6a51', secondary: '#c06565' }
  },
  {
    name: 'rustic',
    label: 'Rustic',
    dark: { primary: '#9d5454', secondary: '#8f9e8a' },
    light: { primary: '#a05f5f', secondary: '#8fa77b' }
  },
  {
    name: 'neon',
    label: 'Neon',
    dark: { primary: '#ff69b4', secondary: '#768bde' },
    light: { primary: '#ec4899', secondary: '#22d3ee' }
  },
  {
    name: 'harvest',
    label: 'Harvest',
    dark: { primary: '#c7a047', secondary: '#f5ae51' },
    light: { primary: '#ddbc58', secondary: '#f3b521' }
  },
  {
    name: 'twilight',
    label: 'Twilight',
    dark: { primary: '#7aa8c3', secondary: '#7e789c' },
    light: { primary: '#6ea7c3', secondary: '#977a7a' }
  },
  {
    name: 'orchid',
    label: 'Orchid',
    dark: { primary: '#be638e', secondary: '#66afa1' },
    light: { primary: '#be638e', secondary: '#66afa1' }
  },
  {
    name: 'steel',
    label: 'Steel',
    dark: { primary: '#91a0a9', secondary: '#ccced0' },
    light: { primary: '#91a0a9', secondary: '#ccced0' }
  },
  {
    name: 'volcanic',
    label: 'Volcanic',
    dark: { primary: '#d9856e', secondary: '#8a76b8' },
    light: { primary: '#b86f5a', secondary: '#6e5d9a' }
  },
  {
    name: 'sage',
    label: 'Sage',
    dark: { primary: '#88b48c', secondary: '#6b9870' },
    light: { primary: '#6b8e6f', secondary: '#5a7d5e' }
  },
  {
    name: 'eggplant',
    label: 'Eggplant',
    dark: { primary: '#6a1b4d', secondary: '#4a0e35' },
    light: { primary: '#5a1642', secondary: '#3f0f2e' }
  },
  {
    name: 'slate',
    label: 'Slate',
    dark: { primary: '#64748b', secondary: '#475569' },
    light: { primary: '#475569', secondary: '#334155' }
  },
  {
    name: 'galaxy',
    label: 'Galaxy',
    dark: { primary: '#9d7cc8', secondary: '#7cc8c8' },
    light: { primary: '#8066aa', secondary: '#66aaaa' }
  },
  {
    name: 'cosmic',
    label: 'Cosmic',
    dark: { primary: '#6e76b8', secondary: '#c87ca8' },
    light: { primary: '#5a609a', secondary: '#aa668e' }
  },
  {
    name: 'storm',
    label: 'Storm',
    dark: { primary: '#6e8585', secondary: '#c8b876' },
    light: { primary: '#5a6e6e', secondary: '#aa9a62' }
  },
  {
    name: 'candy',
    label: 'Candy',
    dark: { primary: '#ffb6c1', secondary: '#87ceeb' },
    light: { primary: '#ff69b4', secondary: '#4682b4' }
  },
  {
    name: 'navy',
    label: 'Navy',
    dark: { primary: '#1e3a5f', secondary: '#152947' },
    light: { primary: '#0f2540', secondary: '#0a1a2e' }
  },
  {
    name: 'grape',
    label: 'Grape',
    dark: { primary: '#9d7cc8', secondary: '#a8c87c' },
    light: { primary: '#8066aa', secondary: '#8aaa66' }
  },
  {
    name: 'olive',
    label: 'Olive',
    dark: { primary: '#9da65d', secondary: '#7f8a44' },
    light: { primary: '#6b7539', secondary: '#596030' }
  },
  {
    name: 'wine',
    label: 'Wine',
    dark: { primary: '#b85b5b', secondary: '#af8c8c' },
    light: { primary: '#662a2a', secondary: '#9a5c5c' }
  }
];

export const THEMES_PER_PAGE = 10;

export const getTotalPages = () => Math.ceil(themes.length / THEMES_PER_PAGE);

export const getThemesByPage = (page) => {
  const startIdx = page * THEMES_PER_PAGE;
  return themes.slice(startIdx, startIdx + THEMES_PER_PAGE);
};

export const getThemeByName = (name) => {
  return themes.find(t => t.name === name);
};
